export const CATEGORY = {
  SIZE: 'design.template.size',
  COLOR: 'theme.type.color',
  PAPER: 'design.template.paper',
  BASIC: 'design.template.basic',
  FORM: 'design.template.form',
  PRINTING_SIDE: 'design.template.printing',
  EFFECT: 'design.template.effects',
  QUANTITY: 'design.template.quantity',
  PAGE: 'design.template.page',
};
